<template>
  <div class="wrap">
    <div class="container container_top">
      <h3 class="pay_titile">邮寄地址</h3>
      <div class="adddz" v-if="address_list.length <= 0">
        <form @submit="saveAddress">
          <div class="address_require">
            <label>
              姓名
              <span>*</span>
            </label>
            <input
              type="text"
              maxlength="50"
              value
              v-model="full_name"
              required
            />
          </div>
          <div class="address_require">
            <label>
              Email
              <span>*</span>
            </label>
            <input type="email" maxlength="50" value v-model="email" required />
          </div>

          <van-row type="flex" align="center" justify="space-between">
            <van-col span="11" class="address_require">
              <label>
                省份
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                value
                @click="showCountryPicker = true"
                v-model="countryName"
              />
              <van-popup v-model="showCountryPicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="countryPicker"
                  @cancel="showCountryPicker = false"
                  @confirm="changeCity($event, 'country')"
                />
              </van-popup>
            </van-col>
          </van-row>

          <van-row type="flex" align="center" justify="space-between">
            <van-col span="11" class="address_require">
              <label>
                城市
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                value
                @click="showStatePicker = true"
                v-model="stateName"
              />
              <van-popup v-model="showStatePicker" position="bottom">
                <van-picker
                  show-toolbar
                  value-key="name"
                  :columns="statePicker"
                  @cancel="showStatePicker = false"
                  @confirm="changeCity($event, 'state')"
                />
              </van-popup>
            </van-col>
            <van-col span="11" class="address_require">
              <label>
                区县
                <span>*</span>
              </label>
              <input
                type="text"
                readonly
                value
                @click="showCityPicker = true"
                v-model="cityName"
              />
              <van-popup v-model="showCityPicker" position="bottom">
                <van-picker
                  value-key="name"
                  show-toolbar
                  :columns="cityPicker"
                  @cancel="showCityPicker = false"
                  @confirm="changeCity($event, 'city')"
                />
              </van-popup>
            </van-col>
          </van-row>
          <div class="address_require">
            <label>
              详细地址
              <span>*</span>
            </label>
            <input type="text" value v-model="address_line" required />
          </div>
          <van-row type="flex" align="center" justify="space-between">
            <van-col span="11" class="address_require">
              <label>
                邮政编码
                <span>*</span>
              </label>
              <input type="text" value v-model="postal_code" />
            </van-col>
            <van-col span="11" class="address_require">
              <label>
                手机号码
                <span>*</span>
              </label>
              <input type="text" value v-model="tel" />
            </van-col>
          </van-row>
          <br />
          <van-row type="flex" align="center" justify="end">
            <van-col>
              <van-button block type="default" native-type="submit" size="small"
                >保存地址</van-button
              >
            </van-col>
          </van-row>
        </form>
      </div>
      <router-link
        class="ress_tz"
        :to="{ path: 'selectaddress', query: { id: base.address.id } }"
        v-if="address_list.length > 0"
      >
        <van-row
          class="pay_reasss"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>
            <van-icon name="location-o" />
          </van-col>
          <van-col style="flex:1">
            <div class="name">
              <span>{{ base.address.name }}</span>
              T:{{ base.address.tel }}
            </div>
            <div>
              {{ base.address.address }} {{ base.address.address_line2 }}
              {{ base.address.city_name }}
              {{ base.address.province_name }}
              {{ base.address.email }}
            </div>
          </van-col>
          <van-col>
            <van-icon name="arrow" />
          </van-col>
        </van-row>
      </router-link>
      <h3 class="pay_titile">付款方式</h3>
      <div class="pay_mode">
        <van-radio-group v-model="radio1">
          <van-radio name="2" checked-color="#FE7A72" @click="chooespay">
            <van-row type="flex" align="center">
              <van-image
                height="20"
                lazy-load
                src="https://www.xiangzh.com/images/alipay.png"
              />
            </van-row>
          </van-radio>
          <br />
          <van-radio name="1" checked-color="#FE7A72" @click="chooespay">
            <van-row type="flex" align="center">
              <van-image
              height="20"
                lazy-load
                src="https://www.xiangzh.com/images/wechat.png"
              />
            </van-row>
          </van-radio>
        </van-radio-group>
        <!-- <div class="adddz" v-if="pay_email_phone">
                    <form >
                        <div class="address_require">
                            <label style="color:red;">请确认您的联系方式，以确保我们能够及时联系: </label>
                            <label>
                                邮箱
                                <span>*</span>
                            </label>
                            <input type="email" maxlength="50" value v-model="email" required/>
                        </div>
                        <div class="address_require">
                            <label>
                                    手机号码
                                    <span>*</span>
                                </label>
                                <input type="text" value v-model="tel"/>
                        </div>
                    </form>
            </div> -->
      </div>


      <div class="carts pay" style="border-top: 8px solid #f3f3f3">
        <h3 class="pay_titile">商品明细</h3>
        <van-card
          v-for="(value, index) in goods_list"
          :key="index"
          :title="value.title"
          :thumb-link="'/#/details/' + value.goods_id"
        >
          <template #thumb>
            <van-image width="88" height="88" lazy-load :src="value.images" />
          </template>
          <template #tags>
            <van-row class="goods_specs" type="flex" justify="start">
              <van-col v-for="(value1, index1) in value.spec" :key="index1"
                >{{ value1.type }}:{{ value1.value }}
              </van-col>
            </van-row>
          </template>
          <template #price>
            <van-row type="flex" align="center" justify="space-between">
              <div class="carts_price">
                价格:
                <font>${{ value.total_price }}</font>
              </div>
              <div class="pay_sj">
                数量:
                <font>{{ value.stock }}</font>
              </div>
            </van-row>
          </template>
        </van-card>
      </div>
      <div class="carts_coupons">
        <h3 class="pay_titile">使用优惠券</h3>
        <van-field
          readonly
          clickable
          error
          right-icon="arrow"
          name="picker"
          :value="coupons"
          label="我的优惠券"
          :placeholder="coupon_text"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            confirm-button-text="确认"
            cancel-button-text="取消"
            :columns="columns"
            value-key="name"
            @confirm="onConfirm"
            @cancel="showPicker = false"
            :default-index="default_index"
          />
        </van-popup>
        <van-field
          v-model="exchange_code"
          center
          clearable
          placeholder="输入优惠券兑换码"
          v-if="user_info"
        >
          <template #button>
            <van-button size="small" type="primary" @click="exchangeCode"
              >兑换</van-button
            >
          </template>
        </van-field>
      </div>

      <div class="pay_wl">
        <h3 class="pay_titile">邮寄方式</h3>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell
              :title="'标准配送（3-7个工作日）'"
              clickable
              @click="radio = '1'"
            >
              <template #label>
                <span style="color: #323233; color: #FE7A72">
                  <span v-if="money_free_shipping_cost == 0">
                    <span style="font-weight: 900">免费送货</span>
                  </span>
                  <span v-if="money_free_shipping_cost > 0">
                    ￥{{ Number(shipping_cost).toFixed(2) }}
                  </span>
                  <span v-if="money_free_shipping_cost - shipping_cost > 0">
                    (Save ￥{{
                      Number(money_free_shipping_cost - shipping_cost).toFixed(
                        2
                      )
                    }})
                  </span>
                </span>
              </template>
              <template #right-icon>
                <van-radio checked-color="#FE7A72" name="1" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <h3 class="pay_titile">订单汇总</h3>
      <div class="address_order_total">
        <van-row
          class="total_list"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>单价:</van-col>
          <van-col>￥{{ Number(item_subtotal).toFixed(2) }}</van-col>
        </van-row>
        <van-row
          class="total_list"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>折扣:</van-col>
          <van-col>￥{{ Number(coupon_money).toFixed(2) }}</van-col>
        </van-row>
        <van-row
          class="total_list"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>运费:</van-col>
          <van-col>￥{{ Number(shipping_cost).toFixed(2) }}</van-col>
        </van-row>
        <van-row
          class="total_list"
          type="flex"
          align="center"
          justify="space-between"
        >
          <van-col>总计:</van-col>
          <van-col>￥{{ Number(grand_total).toFixed(2) }}</van-col>
        </van-row>
      </div>
      <van-row type="flex" align="center" justify="center">
        <div class="payment_but">
          <van-button type="primary" block @click="pay">立即付款</van-button>
        </div>
      </van-row>
    </div>
  </div>
</template>
<style>
.container_top {
  margin-top: 45px;
}
</style>
<script>
export default {
  components: {},
  created() {
    this.buy_type = this.$route.query.buy_type;
    this.ids = this.$route.query.ids;
    this.getData();
    this.user_info = this.getUserInfo();
    this.email = this.user_info.email;
    localStorage.setItem(
      "pay_path",
      "/pay?ids=" + this.ids + "&buy_type=" + this.buy_type
    );
  },
  data() {
    return {
      coupons: "",
      columns: [],
      showPicker: false,
      radio: "1",
      radio1: "2",
      ids: "",
      buy_type: "",
      goods_list: [],
      address_list: [],
      base: [],
      shipping_cost: 0.0,
      grand_total: 0.0,
      coupon_money: 0.0,
      item_subtotal: 0.0,
      money_free_shipping: 0.0,
      money_free_shipping_cost: 0.0,
      coupon_text: "没有可用优惠券",
      coupon_id: 0,
      exchange_code: null,
      address_id: -1,
      goods_id: 0,
      stock: 1,
      spec: "",
      payment_id: 1,
      user_note: "",
      site_model: "",
      user_info: false,

      //地址相关
      showCountryPicker: false,
      countryPicker: [{ id: 0, name: "请选择" }],
      showStatePicker: false,
      statePicker: [{ id: 0, name: "请选择" }],
      showCityPicker: false,
      cityPicker: [{ id: 0, name: "请选择" }],
      countryName: "请选择",
      stateName: "请选择",
      cityName: "请选择",
      country_id: 0,
      province_id: 0,
      city_id: 0,
      email: "",
      full_name: "",
      postal_code: "",
      tel: "",
      address_line: "",
      default_index: 0,
      pay_email_phone: false,
      address_just_email_phone: 0,
    };
  },
  methods: {
    onConfirm(coupons) {
      this.coupon_id = coupons.id;
      this.coupon_text = coupons.name;
      this.showPicker = false;
      if (this.coupon_id > 0) {
        this.getCoupon();
      } else {
        this.coupon_money = 0.0;
        this.CartBaseTotal();
      }
    },
    /**
     * 获取页面数据信息
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    getData() {
      var url = "api/buy/index";
      var data = {};
      if (this.buy_type == "goods") {
        data = JSON.parse(localStorage.getItem("buy_now_goods_info"));
      } else {
        data = { ids: this.ids, buy_type: this.buy_type };
      }
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code == 0) {
          _self.goods_list = data.data.goods_list;
          if (_self.goods_list.length == 1) {
            _self.spec = _self.goods_list[0]["spec"];
          }
          _self.address_list = data.data.user_address_list;
          _self.base = data.data.base;
          if (_self.base.address != null) {
            _self.email = _self.base.address.email;
            _self.tel = _self.base.address.tel;
          }
          _self.item_subtotal = data.data.base.total_price;
          //
          _self.money_free_shipping_cost = data.data.money_free_shipping_cost;
          _self.shipping_cost = data.data.money_free_shipping_cost;
          //over money
          _self.money_free_shipping = data.data.money_free_shipping;
          _self.payment_id = data.data.payment_list[0].id;
          _self.grand_total = data.data.grand_total;
          if (data.data.base.address !== null) {
            _self.address_id = data.data.base.address.id;
          }

          if (_self.grand_total >= _self.money_free_shipping) {
            _self.shipping_cost = 0.0;
          }

          if (data.data.country !== null) {
            _self.countryPicker = _self.countryPicker.concat(data.data.country);
          }
          if (data.data.province !== null) {
            _self.statePicker = _self.statePicker.concat(data.data.province);
          }
          if (data.data.city !== null) {
            _self.cityPicker = _self.cityPicker.concat(data.data.city);
          }

          if (data.data.coupon.length > 0) {
            var coupon_json = [{ id: 0, name: "没有可用优惠券" }];
            var coupon_arr = data.data.coupon;
            for (var i = 0; i < coupon_arr.length; i++) {
              var coupon_ob = {};
              coupon_ob.id = coupon_arr[i].id;
              coupon_ob.name = coupon_arr[i].name;
              coupon_json.push(coupon_ob);
            }
            _self.columns = coupon_json;
            if (data.data.coupon.length == 1) {
              _self.coupon_id = _self.columns[1].id;
              _self.coupon_text = _self.columns[1].name;
              _self.default_index = 1;
              _self.getCoupon();
            }
          }
        }
      });
    },
    /**
     * 获取优惠券金额
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    getCoupon() {
      var url = "api/coupon/couponamount";
      var data = { id: this.coupon_id, total_money: this.item_subtotal };
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code == 0) {
          _self.coupon_money = data.data.coupon_amount;
          _self.CartBaseTotal();
        }
      });
    },
    /**
     * 计算选择的商品总数和总价
     * @author  Devil
     * @version 1.0.0
     * @date    2020-03-21
     * @desc    description
     */
    CartBaseTotal() {
      if (this.item_subtotal - this.coupon_money < this.money_free_shipping) {
        this.shipping_cost = this.money_free_shipping_cost;
      }
      this.grand_total =
        this.item_subtotal - this.coupon_money + this.shipping_cost;
    },
    /**
     * 兑换优惠券
     */
    exchangeCode() {
      this.getUserInfo();
      if (this.exchange_code === "") {
        this.$toast("请输入优惠券兑换码");
        return false;
      }
      var url = "api/coupon/redeemcoupons";
      var data = { exchange_code: this.exchange_code };
      var _self = this;

      this.POST(url, data, function (data) {
        if (data.code === 0) {
          _self.$toast(data.msg);
          setTimeout(function () {
            window.location.reload();
          }, 500);
        } else {
          _self.$toast(data.msg);
        }
      });
    },
    changeCity(e, type) {
      var _self = this;
      var url = "";
      var data = "";
      if (type === "country") {
        if (e.id > 0) {
          this.countryName = e.name;
          this.country_id = e.id;
          this.showCountryPicker = false;
          url = "api/region/index";
          data = { pid: e.id };
          this.POST(url, data, function (ret) {
            if (ret.code === 0) {
              _self.province_id = 0;
              _self.stateName = "请选择";
              _self.statePicker = [{ id: 0, name: "请选择" }];
              _self.statePicker = _self.statePicker.concat(ret.data);

              _self.city_id = 0;
              _self.cityName = "请选择";
              _self.cityPicker = [{ id: 0, name: "请选择" }];
              _self.cityPicker = _self.cityPicker.concat(ret.data);
            }
          });
        } else {
          this.showStatePicker = false;
          this.showStatePicker = false;
          _self.province_id = 0;
          _self.stateName = "请选择";
          _self.statePicker = [{ id: 0, name: "请选择" }];
          _self.city_id = 0;
          _self.cityName = "请选择";
          _self.cityPicker = [{ id: 0, name: "请选择" }];
        }
      } else if (type === "state") {
        if (e.id > 0) {
          this.stateName = e.name;
          this.province_id = e.id;
          this.showStatePicker = false;
          url = "api/region/index";
          data = { pid: e.id };
          this.POST(url, data, function (ret) {
            if (ret.code === 0) {
              _self.city_id = 0;
              _self.cityName = "请选择";
              _self.cityPicker = [{ id: 0, name: "请选择" }];
              _self.cityPicker = _self.cityPicker.concat(ret.data);
            }
          });
        } else {
          this.showStatePicker = false;
          _self.city_id = 0;
          _self.cityName = "请选择";
          _self.cityPicker = [{ id: 0, name: "请选择" }];
        }
      } else if (type === "city") {
        this.cityName = e.name;
        this.city_id = e.id;
        this.showCityPicker = false;
      }
    },
    saveAddress() {
      var _self = this;
      if (this.country_id == 0) {
        this.$toast("请选择省份");
        return false;
      }
      if (this.province_id == 0) {
        this.$toast("请选择城市");
        return false;
      }
      if (this.city_id == 0) {
        this.$toast("请选择区县");
        return false;
      }
      var url = "api/useraddress/save";
      var data = {
        name: this.full_name,
        city: this.city_id,
        email: this.email,
        country: this.country_id,
        province: this.province_id,
        postal_code: this.postal_code,
        tel: this.tel,
        address: this.address_line,
      };
      this.POST(url, data, function (ret) {
        if (ret.code === 0) {
          // window.location.reload();
          _self.$toast('地址保存成功');
        } else {
          _self.$toast(ret.msg);
        }
      });
    },
    pay: async function () {
      // var _self = this;
      // if (this.address_id === -1) {
      //     if (this.full_name == "") {
      //         this.$toast("Please input full name");
      //         return false;
      //     }
      //     if (this.email == "") {
      //         this.$toast("Please input email");
      //         return false;
      //     }
      //     var reg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      //     if (!reg.test(this.email)) {
      //         this.$toast("Email format error");
      //         return false;
      //     }
      //     if (this.address_line == "") {
      //         this.$toast("Please input address line");
      //         return false;
      //     }
      //     if (this.postal_code == "") {
      //         this.$toast("Please input postal code");
      //         return false;
      //     }
      //     if(this.country_id == 0){
      //         this.$toast('Please select a country');
      //         return false;
      //     }
      //     if (this.province_id == 0) {
      //         this.$toast("Please select a state");
      //         return false;
      //     }
      //     if (this.city_id == 0) {
      //         this.$toast("Please select a city");
      //         return false;
      //     }
      //     // if (this.tel == "") {
      //     //     this.$toast("Please input tel");
      //     //     return false;
      //     // }
      //     var url_address = "api/useraddress/save";
      //     var data_address = {
      //         name: this.full_name,
      //         city: this.city_id,
      //         email: this.email,
      //         country:this.country_id,
      //         province: this.province_id,
      //         postal_code: this.postal_code,
      //         tel: this.tel,
      //         address: this.address_line,
      //     };

      //     this.POST(url_address, data_address, function (ret) {
      //         window.console.log(1);
      //         if (ret.code === 0) {
      //             _self.address_id = ret.data.id;
      //             window.console.log(_self.address_id);
      //             _self.go_add();
      //         } else {
      //             _self.$toast(ret.msg);
      //             return false;
      //         }
      //     });
      //     // this.$toast("Please fill in the address");
      //     // return false;
      // } else {
      //     this.go_add();
      // }
      this.go_add();
    },
    go_add() {
      var url = "/api/buy/add";
      var data = {};
      var _self = this;
      if (this.buy_type == "goods") {
        data = {
          goods_id: this.ids,
          buy_type: this.buy_type,
          stock: this.stock,
          spec: this.spec,
          ids: this.ids,
          address_id: this.address_id,
          payment_id: this.payment_id,
          user_note: this.user_note,
          coupon_id: this.coupon_id,
          site_model: 0,
          tel: this.tel,
          email: this.email,
          address_just_email_phone: this.address_just_email_phone,
        };
      } else {
        data = {
          goods_id: 0,
          buy_type: this.buy_type,
          stock: this.stock,
          spec: this.spec,
          ids: this.ids,
          address_id: this.address_id,
          payment_id: this.payment_id,
          user_note: this.user_note,
          coupon_id: this.coupon_id,
          site_model: 0,
          tel: this.tel,
          email: this.email,
          address_just_email_phone: this.address_just_email_phone,
        };
      }
      if (this.radio1 == 2) {
        data.pay_upon_invoice = 1;
      } else {
        if (this.email == "") {
          this.$toast("请填写电子邮件");
          return false;
        }
        if (this.tel == "") {
          this.$toast("请填写手机号码");
          return false;
        }
      }
      this.POST(url, data, function (ret) {
        window.console.log(2);
        if (ret.code === 0) {
          _self.$toast.success(ret.msg);
          window.fbq("trackCustom", "do_pay_now_h5", { id: data.goods_id });
          window.gtag("event", "do_pay_now_h5", {
            method: "do_pay_now_h5",
            content: data.goods_id,
            value: data.goods_id,
            value_goods_id: data.goods_id,
          });
          setTimeout(function () {
            _self.to_pay(ret.data.order.id);
            _self.$toast.loading({
              message: "等待中...",
              forbidClick: true,
            });
          }, 1500);
        } else {
          _self.$toast.fail(ret.msg);
        }
      });
    },
    to_pay(order_id) {
      var _this = this;
      this.POST("api/order/pay", { id: order_id }, function (ret) {
        _this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        if (ret.code === 0) {
          window.location.href = ret.data.data;
        }
      });
    },
    chooespay() {
      if (this.radio1 == 1) {
        this.pay_email_phone = true;
        this.address_just_email_phone = 1;
      } else {
        this.pay_email_phone = false;
        this.address_just_email_phone = 0;
      }
    },
  },
};
</script>